import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { PromocodeForm } from "../PromocodeForm";
import { EditPromocodeModalProps } from "./types";
import { useEditPromocodeModal } from "./controller";

export const EditPromocodeModal = React.memo(({ modalRef, onComplete }: EditPromocodeModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditPromocodeModal({
    modalRef,
    onComplete,
  });

  return (
    <Modal
      ref={modalRef}
      title={translate("promocode_admin.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <PromocodeForm />
    </Modal>
  );
});
